import React from 'react';
import {useTheme} from '@mui/material/styles';
import {Box, Button} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {keyframes} from '@mui/system';
import {motion} from 'framer-motion';
import CustomTooltip from "../CustomTooltip";

interface MuiButtonFilterProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    icon: React.ReactNode;
    label: string;
    animated?: boolean;
    small?: boolean;
    bigAtRender?: boolean;
    isDisabled?: boolean;
    label_position?: "bottom" | "left" | "right" | "top" | "bottom-end" | "bottom-start" | "left-end" | "left-start" | "right-end" | "right-start" | "top-end" | "top-start" | undefined;
}

const pulseAnimation = keyframes({
    '0%': {
        transform: 'scale(1)',
    },
    '50%': {
        transform: 'scale(1.7)',
    },
    '100%': {
        transform: 'scale(1)',
    },
});

const MRTMuiButton: React.FC<MuiButtonFilterProps> = ({
                                                          onClick,
                                                          icon,
                                                          label,
                                                          animated,
                                                          small,
                                                          bigAtRender,
                                                          isDisabled = false,
                                                          label_position = "top"
                                                      }) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const smallStyles = small
        ? {
            padding: '0px 0px',
            minWidth: 'auto',
            fontSize: '0.75rem',
            '& .MuiBox-root': {
                fontSize: '0.75rem',
            },
            '& .MuiSvgIcon-root': {
                fontSize: '1rem',
            },
        }
        : {};

    return (
        <CustomTooltip title={label}>
            <motion.div
                initial={bigAtRender ? {scale: 2.5} : {scale: 1}}
                animate={bigAtRender ? {scale: 1} : {scale: 1}}
                transition={{duration: 0.5}}
            >
                <Button
                    sx={{
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        ...(animated ? {animation: `${pulseAnimation} 1s infinite`} : {}),
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        ...smallStyles,
                    }}
                    aria-label="filter"
                    onClick={onClick}
                    disabled={isDisabled}
                >
                    <Box
                        sx={{
                            backgroundColor: 'transparent',
                            '&:hover': {
                                backgroundColor: 'transparent',
                                color: theme.palette.primary.dark,
                            },
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        {icon}
                    </Box>
                </Button>
            </motion.div>

        </CustomTooltip>
    );
};

export default MRTMuiButton;
